import { createTaxRegion as publicCreateTaxRegion, getTaxRegion as publicGetTaxRegion, updateTaxRegion as publicUpdateTaxRegion, deleteTaxRegion as publicDeleteTaxRegion, queryTaxRegions as publicQueryTaxRegions, } from './billing-v1-tax-region-tax-regions.public.js';
import { createRESTModule } from '@wix/sdk-runtime/rest-modules';
import { createEventModule } from '@wix/sdk-runtime/event-definition-modules';
import { onTaxRegionCreated as publicOnTaxRegionCreated } from './billing-v1-tax-region-tax-regions.public.js';
import { onTaxRegionDeleted as publicOnTaxRegionDeleted } from './billing-v1-tax-region-tax-regions.public.js';
import { onTaxRegionUpdated as publicOnTaxRegionUpdated } from './billing-v1-tax-region-tax-regions.public.js';
export const createTaxRegion = /*#__PURE__*/ createRESTModule(publicCreateTaxRegion);
export const getTaxRegion = /*#__PURE__*/ createRESTModule(publicGetTaxRegion);
export const updateTaxRegion = /*#__PURE__*/ createRESTModule(publicUpdateTaxRegion);
export const deleteTaxRegion = /*#__PURE__*/ createRESTModule(publicDeleteTaxRegion);
export const queryTaxRegions = /*#__PURE__*/ createRESTModule(publicQueryTaxRegions);
/** */
export const onTaxRegionCreated = createEventModule(publicOnTaxRegionCreated);
/**
 * Triggered when a tax region is deleted.
 */
export const onTaxRegionDeleted = createEventModule(publicOnTaxRegionDeleted);
/**
 * Triggered when a tax region is updated.
 */
export const onTaxRegionUpdated = createEventModule(publicOnTaxRegionUpdated);
export { SortOrder, WebhookIdentityType, } from './billing-v1-tax-region-tax-regions.universal.js';
//# sourceMappingURL=billing-v1-tax-region-tax-regions.context.js.map